<template>
  <section id="project-analysis-text-main">
    <Search
      :textAnalysisObject="textAnalysisObject"
      :responsesCount="sortedResponses.length"
      :propReadOnly="propReadOnly"
      :hasPreProcessedText="hasPreProcessedText"
      :includeSmartCoverage="includeSmartCoverage"
      :sortedThemes="sortedThemes"
      :unsortedResponses="unsortedResponses"
      @runSortAndSelect="$emit('runSortAndSelect')"
      @updateTextObject="$emit('updateTextObject', $event)"
      @findSimilar="$emit('findSimilar')"
      @updateFilterParam="$emit('updateFilterParam', $event)"
      @removeThisFilter="$emit('removeThisFilter', $event)"
      @emitSortAndSelect="$emit('emitSortAndSelect')"
      @refreshAllCoverage="$emit('refreshAllCoverage')"
      :searchingForWordAssociations="searchingForWordAssociations"
    />
    <div style="display: flex; flex-direction: row; width: 100%">
      <div class="main__tabs-title" style="display: flex; flex-direction: row; margin-left: 2rem">
        <SvgIconDecorative
          :icon="localActiveTab.toLowerCase() == 'sentiment' ? 'phraseSentiment' : 'tag'"
          class="editor-question__pending-icon"
          style="color: black; margin: auto"
        />
        <h2 style="margin: auto">
          <VisibleText>Text entries</VisibleText>
        </h2>
        <div style="margin: auto; margin-left: 1rem; font-size: 1.2rem">
          {{ `(${responsesCountAfterDroppedAndNotes}/${unsortedResponses.length})` }}
        </div>
      </div>
      <span
        style="margin-left: 1rem; margin-bottom: auto; margin-top: auto; font-size: 1.2rem"
        v-if="
          (sortedResponses.length -
            responsesDroppedCount -
            responsesMLDroppedCount -
            responsesBannedCount) /
            unsortedResponses.length !=
          1
        "
      >
        {{ roundToTwo((responsesCountAfterDroppedAndNotes / unsortedResponses.length) * 100) }}
        %
      </span>
      <button
        class="response-list__load-more-btn"
        style="font-size: 0.8rem; color: var(--secondary-brand-ui-colour)"
        v-if="responsesDroppedCount"
        @click="showOnlyThis('dropped')"
      >
        <VisibleText
          >{{ responsesDroppedCount }} human ignored
          <SvgIconDecorative v-if="filterResponsesBy == 'dropped'" icon="eye"
        /></VisibleText>
      </button>
      <button
        class="response-list__load-more-btn"
        style="font-size: 0.8rem; color: var(--secondary-brand-ui-colour)"
        v-if="responsesMLDroppedCount"
        @click="showOnlyThis('ml_dropped')"
      >
        <VisibleText
          >{{ responsesMLDroppedCount }} AI ignored
          <SvgIconDecorative v-if="filterResponsesBy == 'ml_dropped'" icon="eye"
        /></VisibleText>
      </button>

      <h2 style="margin-left: auto; margin-top: 1rem">
        <div style="display: flex; flex-direction: row">
          <VisibleText>Mode: </VisibleText>
        </div>
      </h2>

      <div style="display: flex; flex-direction: row; position: relative">
        <div style="margin-top: 1rem; display: flex; flex-direction: row; position: relative">
          <SvgIconDecorative
            icon="phraseSentiment"
            class="editor-question__pending-icon"
            style="color: black; margin-left: 5%"
          />
          <div style="width: 5rem">
            <VisibleText>Sentiment analysis</VisibleText>
          </div>
          <div
            @click="setShowSentimentDetails(true)"
            style="
              display: flex;
              cursor: pointer;
              border: 1px solid var(--outline-colour);
              border-radius: 3rem;
              height: 1rem;
              width: 1rem;
              margin-left: 1rem;
            "
          >
            <span style="padding-left: 0.25rem; font-size: 0.8rem; font-weight: 500"> ?</span>
          </div>
          <div @click="showSentimentTip">
            <SwitchToggle
              style="display: flex; margin-left: -0.5rem"
              ref="switch-toggle"
              class="main__tabs-container-options-curr-view switch--small switch--monochromatic"
              :class="!hasPreProcessedText ? 'switch--disabled' : ''"
              title="set current view mode"
              :hasPreProcessedText="hasPreProcessedText"
              :textAnalysisObject="textAnalysisObject"
              @onToggle="handleToggleUpdate"
            />
          </div>
          <SvgIconDecorative
            icon="tag"
            class="editor-question__pending-icon"
            style="color: black"
          />
          <div style="width: 5rem">
            <VisibleText>Thematic analysis</VisibleText>
          </div>

          <div
            @click="showThematicAnalysisInfo = true"
            style="
              display: flex;
              cursor: pointer;
              border: 1px solid var(--outline-colour);
              border-radius: 3rem;
              height: 1rem;
              width: 1rem;
              margin-left: 0.8rem;
              margin-right: 2rem;
            "
          >
            <span style="padding-left: 0.25rem; font-size: 0.8rem; font-weight: 500"> ?</span>
          </div>
        </div>

        <div
          style="
            border-radius: 4px;
            margin: 0.5rem;
            margin-left: auto;
            display: flex;
            flex-direction: row;
          "
        >
          <button class="table__toolbar-btn" @click="toggleShowDownloadOptions">
            <SvgIconDecorative icon="downloadIcon" id="download-icon" />
            Download options
          </button>
          <ButtonIconOnly
            style="
              border: 1px solid var(--outline-colour);
              background: var(--secondary-ui-colour);
              border-radius: 4px;
              margin: 0.5rem;
              margin-right: 1rem;
              display: flex;
            "
            @click-handler="toggleShowRawTable"
            icon="table"
            :propReadOnly="propReadOnly"
          >
            <VisibleText style="font-weight: 800">Show raw table</VisibleText>
          </ButtonIconOnly>
        </div>
        <SentimentsMiniGuide
          @closingGuide="showSentimentsInfo = false"
          :showSentimentsInfo="showSentimentsInfo"
          style="left: -25%; max-width: 35rem"
        >
        </SentimentsMiniGuide>
        <ThematicAnalysisMiniGuide
          @closingGuide="showThematicAnalysisInfo = false"
          :showThematicInfo="showThematicAnalysisInfo"
          style="left: -25%; max-width: 35rem"
        >
        </ThematicAnalysisMiniGuide>

        <div
          style="display: flex; margin-right: 5rem; margin-top: 0.5rem; position: absolute"
          v-if="
            (!hasPreProcessedText || textAnalysisObject.includeSentiments !== 'include') &&
            revealSentimentTip
          "
          @click="revealSentimentTip = false"
        >
          <MessageBlock message-type="warning" title="Sentiment mode disabled">
            You need to activate sentiment mode in the settings of this analysis
          </MessageBlock>
        </div>
      </div>
    </div>

    <div
      v-if="showRawData"
      style="
        padding: 1rem;
        background: var(--base-lighter-ui-colour);
        border: 1px solid var(--outline-light-colour);
        border-radius: 4px;
        margin: 1rem;
      "
    >
      <PositiveNegativeBarChart
        ref="pos-neg-chart"
        class="main__collapsible-chart-content"
        v-if="barChartNode"
        :value="barChartNode"
        @change="selectionChanged"
      />
    </div>
    <div v-if="showDownloadOptions" class="download-options-container">
      <!-- LEFT: Description -->
      <div class="download-description">
        <h2 class="download-title">Download tagged response data</h2>

        <p class="download-instructions">
          Export all responses from this text analysis, including their sentiment scores and the
          themes they were tagged with. Choose the format that best fits how you plan to work with
          the data.
        </p>

        <p class="download-instructions">
          <strong>Theme columns</strong> creates one column per theme, marking each response with a
          <strong>1</strong> or <strong>0</strong>. Ideal for spreadsheets, pivot tables, and
          statistical analysis.
        </p>

        <p class="download-instructions">
          <strong>Single column</strong> places all themes for each response into one cell,
          separated by semicolons. Great for quick review or qualitative analysis.
        </p>
      </div>

      <!-- RIGHT: Controls -->
      <div class="download-controls">
        <!-- Header for the toggle -->
        <div class="download-controls-header">
          <strong>Choose your format</strong>
        </div>

        <!-- Toggle -->
        <div class="export-mode-toggle-wrapper">
          <div class="export-mode-toggle">
            <label :class="{ active: exportMode === 'columns' }">
              <input type="radio" value="columns" v-model="exportMode" />
              Theme columns
            </label>

            <label :class="{ active: exportMode === 'delimited' }">
              <input type="radio" value="delimited" v-model="exportMode" />
              Single column
            </label>
          </div>
        </div>

        <!-- Download button -->
        <button class="btn-default download-btn" role="button" @click.stop="downloadTaggedData">
          <VisibleText>Download to .xlsx</VisibleText>
        </button>
      </div>
    </div>

    <div class="main__tabs-container" v-if="localActiveTab">
      <Spinner
        class="main__tabs-spinner"
        :is-loading="
          textAnalysisObject.showResponseListLoadingSpinner || showResponseListLoadingSpinner
        "
        :componentStyle="true"
        message="loading response items"
        v-if="textAnalysisObject.showResponseListLoadingSpinner || showResponseListLoadingSpinner"
      />
      <div class="main__tabs-container-options" style="display: flex; flex-direction: row">
        <fieldset
          v-if="
            textAnalysisObject.activeTab == 'Sentiment' ||
            textAnalysisObject.selectedThemeUUIDs.length
          "
          class="main__tabs-container-options-highlight"
          style="font-size: 0.8rem; display: flex; z-index: 0; margin-left: 1rem"
        >
          <legend>Select highlight options</legend>
          <div
            class="checkbox-group"
            v-for="(option, index) in tabHighlightFilters[localActiveTab]"
            :key="`highlight-option-${option.id}-${index}`"
          >
            <input
              type="checkbox"
              :id="`highlight-option-${option.id}`"
              :value="option.id"
              v-model="tabHighlightFiltersSelected[localActiveTab]"
            />
            <label
              :for="`highlight-option-${option.id}`"
              :data-parent="$options.name"
              style="font-size: 0.8rem"
            >
              {{ translate(option.label, $options.name) }}
            </label>
          </div>
        </fieldset>
      </div>

      <component
        :is="localActiveTab"
        :ref="'tab' + localActiveTab"
        :propReadOnly="propReadOnly"
        :textAnalysisObject="textAnalysisObject"
        :hasPreProcessedText="hasPreProcessedText"
        :sortedResponsesLength="unsortedResponses.length"
        :includeSmartCoverage="includeSmartCoverage"
        :highlight-filters="tabHighlightFiltersSelected[localActiveTab]"
        :sortedResponses="
          responsesIfDroppedFilter.length ? responsesIfDroppedFilter : sortedResponses
        "
        :sortedThemes="sortedThemes"
        :datasetIDQuestions="datasetIDQuestions"
        :show="true"
        @showSentimentDetails="setShowSentimentDetails($event)"
        @runSortAndSelect="$emit('runSortAndSelect')"
        @updateTextObject="$emit('updateTextObject', $event)"
        @updateTheme="$emit('updateTheme', $event)"
        @refreshTheme="$emit('refreshTheme', $event)"
      ></component>
    </div>
  </section>
</template>

<script>
// Components
import Search from './Components/Search.vue';
import Sentiment from './ProjectAnalysisTextMainSentiment.vue';
import Themes from './ProjectAnalysisTextMainThemes.vue';
import Accordion from '@/components/UI/Accordion.vue';
import SwitchToggle from '@/components/UI/SwitchToggle.vue';
import MessageBlock from '@/components/UI/Message/MessageBlock.vue';
import SentimentsMiniGuide from '@/components/UserGuide/SentimentsMiniGuide.vue';
import ThematicAnalysisMiniGuide from '@/components/UserGuide/ThematicAnalysisMiniGuide.vue';
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';
import ButtonIconOnly from '@/components/UI/Button/ButtonIconOnly.vue';

import { PigeonDocNodeModel, PositiveNegativeBarChart } from '@/pigeondoc/wrapper';

// Mixins
import textAnalysisMixin from '../Mixins/textAnalysisMixin.js';
import SelectTextMixin from './Mixins/selectTextMixin.js';

// Consts
import { HIGHLIGHT_TYPES } from './Utils/constants.js';
//import InlineEditTextInputVue from '../../../../UI/InlineEditTextInput.vue'

const SENTIMENT_FILTER_BY = ['Very positive', 'Positive', 'Neutral', 'Negative', 'Very negative'];
//const SIMILARITY_SCORE_FILTER_BY = []

export default {
  name: 'ProjectAnalysisTextMain',
  mixins: [textAnalysisMixin, SelectTextMixin],
  components: {
    Search,
    Themes,
    Sentiment,
    Accordion,
    SwitchToggle,
    PositiveNegativeBarChart,
    MessageBlock,
    SentimentsMiniGuide,
    ThematicAnalysisMiniGuide,
    SvgIconDecorative,
    SvgIconMeaningful,
    ButtonIconOnly,
  },
  props: {
    datasetIDQuestions: {
      default: () => [],
      type: Array,
    },
    textAnalysisObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    sortedResponses: {
      type: Array,
      required: false,
      default: () => [],
    },
    hasPreProcessedText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    includeSmartCoverage: {
      type: String,
      default: () => 'exclude',
    },
    unsortedResponses: {
      type: Array,
      default: () => [],
    },
    searchingForWordAssociations: {
      type: String,
      default: () => '',
    },
    sortedThemes: {
      type: Array,
      default: () => [],
    },
    showResponseListLoadingSpinner: {
      type: Boolean,
      default: () => false,
    },
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
    filterResponsesBy: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      exportMode: 'delimited',
      tabs: ['Sentiment', 'Themes'],
      localActiveTab: 'Themes',
      responsesDroppedCount: 0,
      responsesMLDroppedCount: 0,
      responsesBannedCount: 0,
      responsesCountAfterDroppedAndNotes: 0,
      responsesIfDroppedFilter: [],
      toggle: 0,
      selected: null, // selected client question
      isAutoGenerateModalVisible: false,
      isMounted: false,
      tabHighlightFilters: {
        Sentiment: [HIGHLIGHT_TYPES['pos-keyword'], HIGHLIGHT_TYPES['neg-keyword']],
        Themes: [
          HIGHLIGHT_TYPES['theme-keyword'],
          HIGHLIGHT_TYPES['theme-note'],
          HIGHLIGHT_TYPES['theme-match'],
        ],
      },
      tabHighlightFiltersSelected: {
        //Sentiment: ["pos-keyword", "neg-keyword"],
        Sentiment: [],
        Themes: ['theme-keyword', 'theme-note', 'theme-match'],
      },
      revealSentimentTip: false,
      showSentimentsInfo: false,
      showThematicAnalysisInfo: false,
      showRawData: false,
      showDownloadOptions: false,
      showOnly: '',
      // pop-up pagination
      sentimentPagination: {
        page: 1,
        limit: 2, //limit of how many are shown in a page
        totalPages: 4,
        startIndx: 0,
        endIndx: 0,
      },
    };
  },
  computed: {
    activePosNegChartType() {
      return 'Responses';
    },
    barChartResponsesFilteredAndSorted() {
      if (!this.sortedResponses) {
        return [];
      }
      return [...this.sortedResponses].map((el) => this.mapResponseToBarChartNodeItem(el));
    },
    barChartNode() {
      if (
        !this.isMounted ||
        this.sortedResponses.length < 1 ||
        (this.localActiveTab.toLowerCase() !== 'sentiment' &&
          this.localActiveTab.toLowerCase() !== 'themes')
      ) {
        return false;
      }

      const title = this.activePosNegChartType;
      const tableColumns = ['row', 'response', 'score', 'sentiment', 'themes'];
      const tableFilterByLabel = SENTIMENT_FILTER_BY;

      const SCALE_DOWN_FACTOR = Math.ceil(
        Math.max(this.barChartResponsesFilteredAndSorted.length) / 1000,
      );

      let shortenedData = [];
      let filteredData = this.deepCloneObj(this.barChartResponsesFilteredAndSorted);
      if (this.barChartResponsesFilteredAndSorted.length > 8000) {
        shortenedData = filteredData.filter((_, index) => index % SCALE_DOWN_FACTOR === 0);
      } else {
        shortenedData = filteredData;
      }

      // PigeonDoc isn't optimized to use both data and data_ALL due to bugs
      return new PigeonDocNodeModel({
        type: 'positiveNegativeBarChart',
        content: {
          title: `${title}`,
          data: shortenedData,
          data__ALL: shortenedData,
        },
        meta: {
          veryPositiveColour: 'var(--very-positive-soft)',
          positiveColour: 'var(--somewhat-positive-soft)',
          neutralColour: 'var(--neutral-soft)',
          negativeColour: 'var(--somewhat-negative-soft)',
          veryNegativeColour: 'var(--very-negative-soft)',
          highlightColour: '#56b4e9',
          selectedColour: '#0072b2',
          headingLevel: 'h4',
          hasPreProcessedText: this.hasPreProcessedText,
          includeSentiments: this.textAnalysisObject.includeSentiments,
          isSentimentChart: true,
          isSentimentMode: this.localActiveTab.toLowerCase() == 'sentiment',
          table: {
            columns: tableColumns,
            filterByLabel: tableFilterByLabel,
          },
        },
      });
    },
  },
  mounted() {
    this.isMounted = true;
    if (this.textAnalysisObject) {
      this.updateLocalActiveTab();
      if (
        this.textAnalysisObject.selectedTextQuestion &&
        this.textAnalysisObject.selectedTextQuestion._id
      ) {
        this.selected = this.textAnalysisObject.selectedTextQuestion._id.$oid;
      }
      if (this.localActiveTab == 'Themes' || (this.sortedThemes && this.sortedThemes.length)) {
        this.$refs['switch-toggle'].value = 1;
      }
      this.updateCounts();
    }
    if (!this.hasPreProcessedText) {
      this.$refs['switch-toggle'].value = 1;
    }
  },
  methods: {
    toggleShowRawTable() {
      this.showRawData = !this.showRawData;
    },
    toggleShowDownloadOptions() {
      this.showDownloadOptions = !this.showDownloadOptions;
    },
    async downloadTaggedData() {
      const tq = this.textAnalysisObject?.selectedTextQuestion;
      if (!tq?._id) return;

      const projectId = this.project?.id;
      const uuid = this.textAnalysisObject?.uuid;
      if (!projectId || !uuid) return;

      const clientQuestionId = tq._id.$oid || tq._id;

      try {
        await this.TEXT_SERVICE.downloadTaggedDataExcel(
          projectId,
          clientQuestionId,
          uuid,
          this.textAnalysisObject?.filterParams || {},
          this.exportMode,
        );
      } catch (err) {
        // eslint-disable-next-line
        console.error('downloadTaggedData failed:', err);
      }
    },

    updateCounts() {
      // Apply drop filters if active
      // e.g. ML dropped, or human dropped
      if (this.filterResponsesBy) {
        const filteredThemes = this.sortedThemes.filter((t) =>
          this.textAnalysisObject.selectedThemeUUIDs.includes(t._id),
        );

        this.responsesIfDroppedFilter = this.filterResponsesByDropState(
          this.sortedResponses,
          filteredThemes,
          this.filterResponsesBy,
        );
      }

      // Nothing selected, no 'dropped' logic to apply
      if (!this.textAnalysisObject.selectedThemeUUIDs.length) {
        this.responsesCountAfterDroppedAndNotes = this.sortedResponses.length;
        return;
      }

      // Dropped logic needs themes present
      if (!this.sortedThemes.length) {
        return;
      }

      // For UI, letting users filter all dropped
      // -----------------------------------------
      const relevantThemes = this.sortedThemes.filter((theme) =>
        this.textAnalysisObject.selectedThemeUUIDs.includes(theme._id),
      );

      // UI dropped
      let relevantDropped = [];
      for (let i = 0; i < relevantThemes.length; i++) {
        relevantDropped = relevantDropped.concat(relevantThemes[i].dropped);
      }
      this.responsesDroppedCount = this.sortedResponses.filter((response) =>
        relevantDropped.includes(response.id),
      ).length;

      // UI ML dropped
      let relevantMLDropped = [];
      for (let i = 0; i < relevantThemes.length; i++) {
        relevantMLDropped = relevantMLDropped.concat(relevantThemes[i].ml_dropped);
      }
      this.responsesMLDroppedCount = this.sortedResponses.filter((response) =>
        relevantMLDropped.includes(response.id),
      ).length;

      // For aligning with coverage:
      // ---------------------------
      // We need to subtract only drops NOT overridden by notes.
      // And avoid double-subtracting if a response appears in both dropped + ml_dropped.

      // Collect all note IDs across selected themes
      const noteIds = new Set();
      for (const theme of relevantThemes) {
        theme.notes.forEach((n) => noteIds.add(n.responseId));
      }

      // Collect dropped and ml_dropped into sets (avoid duplicates)
      const droppedIds = new Set(relevantDropped);
      const mlDroppedIds = new Set(relevantMLDropped);

      // Count coverage-valid dropped (not overridden by notes)
      let coverageDroppedCount = 0;
      for (const id of droppedIds) {
        if (!noteIds.has(id)) {
          coverageDroppedCount++;
        }
      }

      // Count coverage-valid ml_dropped (not overridden by notes AND not already counted)
      let coverageMLDroppedCount = 0;
      for (const id of mlDroppedIds) {
        if (!noteIds.has(id) && !droppedIds.has(id)) {
          coverageMLDroppedCount++;
        }
      }

      // Now compute the adjusted numerator
      this.responsesCountAfterDroppedAndNotes =
        this.sortedResponses.length - coverageDroppedCount - coverageMLDroppedCount;

      // Update banned (adjust the denominator)
      // --------------------------------------
      if (!this.textAnalysisObject.bannedComments.length) {
        return 0;
      }

      const bannedCount = this.sortedResponses.filter((response) =>
        this.textAnalysisObject.bannedComments.includes(response.id),
      ).length;

      this.responsesBannedCount = bannedCount;
    },

    filterResponsesByDropState(responses, themes, mode) {
      if (!mode) return responses;

      // Collect all dropped / ml_dropped IDs across selected themes
      const droppedIds = new Set();
      const mlDroppedIds = new Set();

      themes.forEach((t) => {
        (t.dropped || []).forEach((id) => droppedIds.add(id));
        (t.ml_dropped || []).forEach((id) => mlDroppedIds.add(id));
      });

      switch (mode) {
        case 'dropped':
          return responses.filter((r) => droppedIds.has(r.id));

        case 'ml_dropped':
          return responses.filter((r) => mlDroppedIds.has(r.id));

        case 'not_dropped':
          return responses.filter((r) => !droppedIds.has(r.id));

        case 'not_ml_dropped':
          return responses.filter((r) => !mlDroppedIds.has(r.id));

        default:
          return responses;
      }
    },

    updateLocalActiveTab() {
      this.localActiveTab = this.textAnalysisObject.activeTab;
    },
    roundToTwo(num) {
      return +(Math.round(num + 'e+2') + 'e-2');
    },
    updateTextObject(cleanedProject) {
      let object = {
        project: cleanedProject,
        scroll: 'main',
      };
      this.$emit('updateTextObject', object);
    },
    refreshThemesFromParent() {
      if (this.$refs.tabSentiment) {
        this.$refs.tabSentiment.refreshThemesFromParent();
      }
      if (this.$refs.tabThemes) {
        this.$refs.tabThemes.refreshThemesFromParent();
      }
    },
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
    mapResponseToBarChartNodeItem(el) {
      let default_score = null;
      if (
        el.response_sentiment_bert &&
        typeof el.response_sentiment_bert.compound_score !== 'undefined'
      ) {
        default_score = el.response_sentiment_bert.compound_score;
      }
      if (this.textAnalysisObject.adjustedSentiments) {
        const adjustedSentiment = this.textAnalysisObject.adjustedSentiments.filter(
          (val) => val.responseId == el.id,
        );

        if (adjustedSentiment != null && adjustedSentiment.length) {
          default_score = adjustedSentiment[0].adjustedSentiment;
        }
      }

      // if (default_score == null) {
      //   return {}
      // }
      return {
        id: el.id,
        responseID: el.row_index,
        response: el.response,
        score: default_score,
        label: this.getScoreLabel(default_score),
        themes: this.getMatchingThemes(el),
      };
    },
    shouldRenderPosNegChart(bool) {
      if (!bool) return;
      if (!this.$refs['pos-neg-chart']) return;
      this.$refs['pos-neg-chart'].renderChart();
    },
    getScoreLabel(score) {
      let thisScore = '';
      if (score >= 0.75) thisScore = 'Very positive';
      if (score < 0.75) thisScore = 'Positive';
      if (score < 0.25) thisScore = 'Neutral';
      if (score <= -0.25) thisScore = 'Negative';
      if (score <= -0.75) thisScore = 'Very negative';
      return thisScore;
    },

    getMatchingThemes(el) {
      // This is used by sentiment but also downloading, so we TRUST the backend to properly fill matching_responses. We are not trying to 'catch' keyword, notes, or dropped logic.
      if (!this.sortedThemes?.length) return '';

      const responseId = el.id;
      const names = [];

      const filtersActive =
        this.textAnalysisObject.filterParams &&
        Object.keys(this.textAnalysisObject.filterParams).length;

      for (let i = 0; i < this.sortedThemes.length; i++) {
        const theme = this.sortedThemes[i];

        // Choose authoritative backend list
        const cov = filtersActive ? theme.filtered_coverage : theme.coverage;
        const matches = cov?.matching_responses || [];

        // Only backend authoritative match counts
        if (!matches.includes(responseId)) continue;

        names.push(theme.name);
      }

      return names.join('; ');
    },

    /* Switch toggle methods */
    async handleToggleUpdate() {
      let tab = '';
      if (this.localActiveTab == 'Sentiment') {
        tab = 'Themes';
      } else {
        tab = 'Sentiment';
      }
      if (tab) {
        this.localActiveTab = tab;
        await this.setActiveTab(tab);
      }
    },

    showSentimentTip() {
      this.revealSentimentTip = !this.revealSentimentTip;
      if (this.revealSentimentTip) {
        setTimeout(() => {
          this.revealSentimentTip = false;
        }, 2000);
      }
    },
    onClickNextPage() {
      if (this.sentimentPagination.page === this.sentimentPagination.totalPages) return;
      this.sentimentPagination.page = this.sentimentPagination.page + 1;
      this.setPaginationDetails(
        this.sentimentPagination.startIndx + this.sentimentPagination.limit,
        this.sentimentPagination.endIndx + this.sentimentPagination.limit,
      );
    },
    onClickPrevPage() {
      if (this.sentimentPagination.page === 1) return;
      this.sentimentPagination.page = this.sentimentPagination.page - 1;
      this.setPaginationDetails(
        this.sentimentPagination.startIndx - this.sentimentPagination.limit,
        this.sentimentPagination.endIndx - this.sentimentPagination.limit,
      );
    },
    setPaginationDetails(start, end) {
      this.sentimentPagination.startIndx = start;
      this.sentimentPagination.endIndx = end;
    },
    setShowSentimentDetails(val) {
      if (val) {
        this.showSentimentsInfo = true;
      }
    },
    showOnlyThis(type) {
      if (type === 'dropped') {
        this.showOnly = this.showOnly === 'dropped' ? '' : 'dropped';
      } else if (type === 'ml_dropped') {
        this.showOnly = this.showOnly === 'ml_dropped' ? '' : 'ml_dropped';
      }

      this.$emit('filterResponsesBy', this.showOnly);
    },
  },
  watch: {
    localActiveTab: function (val) {
      if (!val) return;
      if (val === 'Sentiment' && this.toggle === 1) this.$refs['switch-toggle'].value = 0;
      if (val === 'Themes' && this.toggle === 0) this.$refs['switch-toggle'].value = 1;
    },
    textAnalysisObject: function (val) {
      if (val) {
        if (
          this.textAnalysisObject.selectedTextQuestion &&
          this.textAnalysisObject.selectedTextQuestion._id.$oid
        ) {
          this.selected = this.textAnalysisObject.selectedTextQuestion._id.$oid;
        } else {
          this.selected = null;
        }
        this.updateCounts();
      }
    },
    filterResponsesBy: function (val) {
      if (val) {
        const filteredThemes = this.sortedThemes.filter((t) =>
          this.textAnalysisObject.selectedThemeUUIDs.includes(t._id),
        );

        this.responsesIfDroppedFilter = this.filterResponsesByDropState(
          this.sortedResponses,
          filteredThemes,
          this.filterResponsesBy,
        );
      } else {
        this.responsesIfDroppedFilter = [];
      }
    },
  },
};
</script>

<style scoped>
.export-mode-toggle-wrapper {
  display: flex;
  justify-content: flex-start;
  margin: 0.5rem 0 1rem 0;
}

.export-mode-toggle {
  display: inline-flex;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  overflow: hidden;
  background: #f6f8fa;
}

.export-mode-toggle label {
  padding: 8px 14px;
  cursor: pointer;
  font-size: 13px;
  background: #f6f8fa;
  color: #444;
  border-right: 1px solid #d0d7de;
  user-select: none;
  transition:
    background 0.15s,
    color 0.15s;
}

.export-mode-toggle label:last-child {
  border-right: none;
}

.export-mode-toggle input {
  display: none;
}

.export-mode-toggle label.active {
  background: var(--primary);
  color: white;
}

@media (max-width: 750px) {
  .export-mode-toggle-wrapper {
    justify-content: center;
  }
}
.download-options-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
  padding: 1rem;
  background: var(--base-lighter-ui-colour);
  border: 1px solid var(--outline-light-colour);
  border-radius: 4px;
  margin: auto;
  width: 50vw;
}

/* LEFT SIDE */
.download-description {
  flex: 2;
  max-width: 650px;
}

/* RIGHT SIDE */
.download-controls {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.download-controls-header {
  font-size: 0.95rem;
  color: #333;
  margin-bottom: -0.25rem;
}

/* Toggle styling (unchanged) */
.export-mode-toggle-wrapper {
  display: flex;
}

.export-mode-toggle {
  display: inline-flex;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  overflow: hidden;
  background: #f6f8fa;
}

.export-mode-toggle label {
  padding: 8px 14px;
  cursor: pointer;
  font-size: 13px;
  background: #f6f8fa;
  color: #444;
  border-right: 1px solid #d0d7de;
  user-select: none;
  transition:
    background 0.15s,
    color 0.15s;
}

.export-mode-toggle label:last-child {
  border-right: none;
}

.export-mode-toggle input {
  display: none;
}

.export-mode-toggle label.active {
  background: var(--primary);
  color: white;
}

/* Mobile */
@media (max-width: 750px) {
  .download-options-container {
    flex-direction: column;
    align-items: center;
  }

  .download-controls {
    width: 100%;
    align-items: center;
  }
}
</style>
